import React from "react";

// {state.isError && <showObjErrors obj={state.isErrorMessage} />}
export const showObjErrors = ({ obj }) => (
  <>
    {Object.keys(obj[0]).map((key, pos) => (
      <div key={pos}>
        {key}: {obj[0][key]}
      </div>
    ))}
  </>
);

// {state.isError && <ShowErrors arr={state.isErrorMessage} />}
export const ShowErrors = ({ arr }) =>
  arr.map((txt, pos) => <div key={pos}>{txt}</div>);

export const getUrlParameter = (name) => {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  const results = regex.exec(location.search);

  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

// https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
export const getParameterByName = (url, name) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const encodeURLByObject = (obj) =>
  Object.keys(obj)
    .map((v) => encodeURIComponent(v) + "=" + encodeURIComponent(obj[v]))
    .join("&");

export const isActiveToken = () =>
  window.localStorage.getItem("token") !== null

export const getToken = () =>
  window.localStorage.getItem("token");

export const saveToken = (token) =>
  window.localStorage.setItem("token", token);

export const clearToken = () =>
  window.localStorage.removeItem("token");

export const axiosHeadersConfig = () => {
  const Authorization = `Token ${getToken()}`;

  return { headers: { Authorization } };
};

export const isValidDate = (str = "2000-12-01") =>
  /^\d{4}[-]\d{2}[-]\d{2}$/.test(str);

export const parseDateString = (str) => str.substring(0, 10).replace(/-/g, "/");
